module.exports = __webpack_public_path__ + "static/img/pc.c419cd6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cn/北京通州华仁学校/pc.svg
// module id = pHW1
// module chunks = 16